import { ApolloClient, ApolloLink, from, HttpLink, NormalizedCacheObject } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import typeDefs from '@/graphql/typeDefs/schema.graphql';
import { apiUrl } from '@/services/config';
import { addErrorToTracker } from '@/services/datadog';

import cache from './cache';

const APOLLO_CLIENT_DEFAULT_OPTIONS = {
	name: 'dev-console',
	version: '1.0',
};

const httpLink = new HttpLink({
	uri: apiUrl,
	credentials: 'same-origin',
	fetchOptions: {
		mode: 'cors',
	},
});

const errorLink = onError(({ graphQLErrors = [], networkError }) => {
	if (graphQLErrors.length > 0) {
		addErrorToTracker(graphQLErrors, 'network');
	} else if (networkError) {
		addErrorToTracker(graphQLErrors.length > 0 ? graphQLErrors : networkError, 'network');
	}
});

const getClient = (token: string | null = null): ApolloClient<NormalizedCacheObject> => {
	const authLink = new ApolloLink((operation, forward) => {
		if (token) {
			operation.setContext(({ headers }: { headers: Record<string, unknown> }) => ({
				headers: {
					...headers,
					...{ Authorization: `Bearer ${token}` },
				},
			}));
		}

		return forward(operation);
	});

	return new ApolloClient({
		...APOLLO_CLIENT_DEFAULT_OPTIONS,
		ssrMode: typeof window === 'undefined',
		link: from([errorLink, authLink, httpLink]),
		typeDefs,
		cache,
		defaultOptions: {
			watchQuery: {
				fetchPolicy: 'cache-and-network',
			},
			query: {
				fetchPolicy: 'network-only',
			},
		},
	});
};

export default getClient;
